export class ObjectHelper {
  static objectToArray<T extends object, F>(obj: T, mapper: (val) => F) {
    return Object.entries(obj).map(mapper);
  }
}
